export default __webpack_public_path__ + "static/flow-1-92020bab6e620864a270f4f03e0e681c.png";